module.exports = __webpack_public_path__ + "media/images/landkit/patterns/pattern-1-ad78d27a2f4c06d14127b8a21fa79fb6.svg";